export default "__VITE_ASSET__e3c6ac4d__"